import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Typography from "@components/Typography";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { withStyles } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import clsx from "clsx";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledTabs = withStyles((theme) => ({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    // "& > div": {
    //   maxWidth: theme.spacing(14),
    //   borderRadius: theme.spacing(1),
    //   width: "100%",
    //   backgroundColor: theme.palette.primary.main,
    // },
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export default function TabsPanel({
  tabs,
  changeRoute,
  mainRouterBase,
  extraText,
  size,
  smallTabs,
  overrideValue,
  setOverrideValue,
  params,
  ...rest
}) {
  const classes = useStyles();
  const history = useHistory();
  const { page } = useParams();
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!!params) {
      if (params === "deposit") {
        setValue(0);
      } else if (params === "withdraw") {
        setValue(1);
      } else if (params === "open-orders") {
        setValue(2);
      }
    }
  }, []);
  const mapValu2Id = (page) => {
    return tabs.filter((x) => x.name === page).map((x) => x.id)[0];
  };

  useEffect(() => {
    if (!!page && changeRoute) {
      setValue(mapValu2Id(page));
    }
  }, [page]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (!!setOverrideValue) {
      setOverrideValue(newValue);
    }
    if (changeRoute) {
      history.push(mainRouterBase + tabs[newValue].name);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar} {...rest}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          className={clsx(
            smallTabs && classes.smallTabs,
            size === "small" && classes.small
          )}
        >
          {tabs.map((tab, index) => (
            <Tab label={tab.label} {...a11yProps(index)} />
          ))}
        </StyledTabs>
      </AppBar>
      {!!extraText && (
        <div className={clsx(classes.extraText, classes.action)}>
          {extraText}
        </div>
      )}
      {tabs.map(
        (tab, index) =>
          value === index && (
            <div className={classes.extraText}>{tab.action}</div>
          )
      )}
      {tabs.map((tab, index) => (
        <TabPanel value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </div>
  );
}
